import { createSelector } from 'reselect';
import { RootState } from '../store';

const selectSettingsState = (state: RootState) => state.settings;

export const selectLanguage = createSelector(
  selectSettingsState,
  (settingsState) => settingsState.language
);

export const selectRigiLanguage = createSelector(
  selectSettingsState,
  (settingsState) => settingsState.rigiLanguage
);